declare var moment: any;
declare var bsCustomFileInput: any;

$(document).ready(() => {
  MaterialPro.construct();

  moment.tz.setDefault("America/New_York");

  Navigation.construct();
  Parameters.construct();
  AjaxSave.construct();
  Check.construct();
  FormButtons.construct();
  ContentEditableDivAjaxSave.construct();
  Lockable.construct();
  UspsValidatedAddress.construct();
  UserAssignmentTable.construct();

  //Pickers
  FieldOfficePicker.construct();
  DdsOfficePicker.construct();
  OhoOfficePicker.construct();
  HearingLocationPicker.construct();

  //Input
  ContentEditableDiv.construct();
  Masks.construct();
  SelectTools.initDataApi();
  CheckableDateBox.construct();
  YesNoButton.construct();
  ConditionalFormControls.construct();
  bsCustomFileInput.init();

  Notifications.construct();

  ChromeFixes.construct();

  $("input").attr("autocomplete", "this-is-ridiculous");

  $(function () {
    $('[data-toggle="tooltip"]').tooltip();
  });
  $(function () {
    $('[data-toggle="popover"]').popover();
  });
});